export const VERSION = "0.36.3"
export const WASM_WNFS_VERSION = "0.1.7"
